import { Box, Typography } from "@outschool/backpack";
import { IconButton, Space } from "@outschool/ui-legacy-component-library";
/* eslint-disable i18next/no-literal-string */
import React from "react";

export default ({ label, onClick, icon }: $TSFixMe) => {
  return (
    <Box
      flex
      sx={{
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <IconButton
        icon={icon}
        onClick={onClick}
        sx={{
          backgroundColor: "rgba(204, 213, 255, 0.5)",
          borderRadius: "50%",
          color: "peacock300",
        }}
      />
      <Space y={4} />
      <Typography
        variant="inherit"
        sx={{
          fontSize: 12,
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};
